import { render, staticRenderFns } from "./bkManage.vue?vue&type=template&id=74cfba66"
import script from "./bkManage.vue?vue&type=script&lang=js"
export * from "./bkManage.vue?vue&type=script&lang=js"
import style0 from "./bkManage.vue?vue&type=style&index=0&id=74cfba66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports